import React, { Component } from "react";
import AnchorLink from "react-anchor-link-smooth-scroll"

export class BackToTop extends Component {
    render() {
        return <AnchorLink className="back-to-top inner-link" href="#start" data-scroll-class="100vh:active">
            <i className="stack-interface stack-up-open-big"/>
        </AnchorLink>;
    }
}